export default __webpack_public_path__ + "static/media/image3.610f9f03.png";